import api from './api';

// --- Article Running Titles ---

// Get All Running Titles
export const getAllRunningTitles = async () => {
    try {
        const response = await api.get('/admin/running-titles');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get Running Title by ID
export const getRunningTitleById = async (id) => {
    try {
        const response = await api.get(`/admin/running-titles/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Create Running Title
export const createRunningTitle = async (titleData) => {
    try {
        const response = await api.post('/admin/running-titles', titleData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update Running Title
export const updateRunningTitle = async (id, titleData) => {
    try {
        const response = await api.put(`/admin/running-titles/${id}`, titleData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete Running Title
export const deleteRunningTitle = async (id) => {
    try {
        const response = await api.delete(`/admin/running-titles/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get Pending Running Titles (For Approval)
export const getPendingRunningTitles = async () => {
    try {
        const response = await api.get('/admin/running-titles/pending');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Approve Running Title
export const approveRunningTitle = async (id, approvalData) => {
    try {
        const response = await api.put(`/admin/running-titles/${id}/approve`, approvalData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Professor Management ---

// Get all professors
export const getProfessors = async () => {
    try {
        const response = await api.get('/admin/professors');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Editorial Board ---

// Get all editorial board assignments
export const getEditorialAssignments = async () => {
    try {
        const response = await api.get('/admin/editorial-assignments');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Promote professor to editorial board
export const assignToEditorialBoard = async (assignmentData) => {
    try {
        const response = await api.post('/admin/editorial-assignments', assignmentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Remove professor from editorial board
export const removeFromEditorialBoard = async (id) => {
    try {
        const response = await api.delete(`/admin/editorial-assignments/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Reviewers ---

// Get all reviewers
export const getReviewers = async () => {
    try {
        const response = await api.get('/admin/reviewers');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Promote professor to reviewer
export const assignAsReviewer = async (reviewerData) => {
    try {
        const response = await api.post('/admin/reviewers', reviewerData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Remove professor from reviewer list (Standardizing for UI)
export const removeFromReviewers = async (id) => {
    try {
        const response = await api.delete(`/admin/reviewers/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Authorized Numbers ---
export const getAuthorizedNumbers = async (params = {}) => {
    try {
        const response = await api.get('/admin/authorized-numbers', { params });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const createAuthorizedNumber = async (data) => {
    try {
        const response = await api.post('/admin/authorized-numbers', data);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const updateAuthorizedNumber = async (id, data) => {
    try {
        const response = await api.put(`/admin/authorized-numbers/${id}`, data);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const deleteAuthorizedNumber = async (id) => {
    try {
        const response = await api.delete(`/admin/authorized-numbers/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Unauthorized Applications Rejection ---

// Get unauthorized reviewers
export const getUnauthorizedReviewers = async () => {
    try {
        const response = await api.get('/admin/unauthorized-reviewers');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get unauthorized editorial board
export const getUnauthorizedEditorialBoard = async () => {
    try {
        const response = await api.get('/admin/unauthorized-editorial-board');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Reject unauthorized reviewer
export const rejectUnauthorizedReviewer = async (professorId) => {
    try {
        const response = await api.delete(`/admin/unauthorized-reviewers/${professorId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Reject unauthorized editorial board
export const rejectUnauthorizedEditorialBoard = async (professorId) => {
    try {
        const response = await api.delete(`/admin/unauthorized-editorial-board/${professorId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get Submitted Articles (For Selected Students)
export const getSubmittedArticles = async () => {
    try {
        const response = await api.get('/admin/articles/submitted');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Sub-EB Management ---

// Get all Sub-EB requests
export const getSubEBRequests = async () => {
    try {
        const response = await api.get('/admin/sub-eb/requests');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Verify a Sub-EB request
export const verifySubEB = async (userId) => {
    try {
        const response = await api.post('/admin/sub-eb/verify', { user_id: userId });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Revoke Editorial Board rights
export const revokeSubEB = async (userId) => {
    try {
        const response = await api.post('/admin/sub-eb/revoke', { user_id: userId });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get already verified Sub-EB users
export const getVerifiedSubEBUsers = async () => {
    try {
        const response = await api.get('/admin/sub-eb/users');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Article Publication ---

// Publish an article and declare results
export const publishArticle = async (articleId) => {
    try {
        const response = await api.put(`/admin/articles/${articleId}/publish`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Get winners for a running title
export const getRunningTitleWinners = async (runningTitleId) => {
    try {
        const response = await api.get(`/admin/running-titles/${runningTitleId}/winners`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Journal Submissions ---

// Get all journal submissions (abstracts)
export const getJournalSubmissions = async () => {
    try {
        const response = await api.get('/admin/journal/submissions');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Assign/Update reviewer for an abstract
export const assignAbstractReviewer = async (submissionId, reviewerData) => {
    try {
        const response = await api.post(`/admin/journal/submissions/${submissionId}/assign`, reviewerData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// New Assign Reviewer Endpoint (Standardized)
export const assignReviewer = async (assignmentData) => {
    try {
        const response = await api.post('/admin/journal/assign-reviewer', assignmentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Reassign Reviewer
export const reassignReviewer = async (assignmentData) => {
    try {
        const response = await api.post('/admin/journal/reassign-reviewer', assignmentData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Payment Management & Refunds ---

// Get all payments (Admin only)
export const getAllPayments = async () => {
    try {
        const response = await api.get('/admin/payment');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Initiate refund (Admin only)
export const initiateRefund = async (paymentId, amount) => {
    try {
        // backend expects { payment_id, amount }
        const response = await api.post('/admin/payment/refund', {
            payment_id: paymentId,
            amount: amount
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Global Settings ---
export const getGlobalSettings = async () => {
    try {
        const response = await api.get('/admin/settings');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const updateGlobalSetting = async (key, value) => {
    try {
        const response = await api.put('/admin/settings', { key, value });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- University Management ---
export const toggleUniversityFreeSignup = async (id, isFree) => {
    try {
        const response = await api.put(`/admin/universities/${id}/free-signup`, { is_free_signup: isFree });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- YI Article Payment Settings ---
export const getYIArticlePaymentSettings = async () => {
    try {
        const response = await api.get('/admin/yi-article-payment-settings');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const updateYIArticlePaymentSetting = async (key, value) => {
    try {
        const response = await api.put('/admin/yi-article-payment-settings', { key, value });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const toggleUniversityFreeYIArticle = async (id, isFree) => {
    try {
        const response = await api.put(`/admin/universities/${id}/free-yi-article`, { is_free_yi_article: isFree });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Young India Students ---
export const getYoungIndiaStudents = async () => {
    try {
        const response = await api.get('/admin/yi-students');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
